module.exports = "/packs/images/svg/weekly-prog/info~a19912f5a1da53558fcdd8e3291bd15e.svg";